import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.css']
})
export class FormFieldComponent implements OnInit, OnChanges {
  @Input() autofocus: boolean = false;

  @Input() customLabel: boolean = false;

  @Input() disabled: boolean = false;

  @Input() inputName: string = `v6-${Math.random().toString(36).slice(2)}`;

  @Input() label: string;

  @Input() inline: boolean = false;

  @Input() helpText: string;

  @Input() model: string;

  @Input() placeholder: string = '';

  @Input() small: boolean = false;

  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  inputValue: string;

  constructor() { }

  ngOnInit(): void {
    this.assignFormInputValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.model){
      this.assignFormInputValue();
    }
  }

  assignFormInputValue() {
    this.inputValue = this.model;
  }

  updateFormInputValue() {
    this.modelChange.emit(this.inputValue);
  }
}
